module.exports = __webpack_public_path__ + "static/media/mid_rhs.7286e5f6.png";